{
  "errors": {
    "tileFailed": "DEM tile {{tile}} failed"
  }
}
